module.exports = __webpack_public_path__ + "static/img/1.c577392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experiment8/1.png
// module id = i8xb
// module chunks = 0